import { Host, h } from "@stencil/core";
/**
 * @slot - The content of this node.
 * @slot children - The content nested under this node.
*/
export class DnnTreeviewItem {
    constructor() {
        /** Defines if the current node is expanded.  */
        this.expanded = false;
        /** Manages state for whether or not item has children. */
        this.hasChildren = false;
        this.focused = false;
    }
    /** Watch expanded Prop */
    watchExpanded(expanded) {
        if (expanded) {
            this.expander.classList.add("expanded");
            this.collapsible.expanded = true;
            return;
        }
        this.expander.classList.remove("expanded");
        this.collapsible.expanded = false;
    }
    componentDidLoad() {
        requestAnimationFrame(() => {
            const child = this.childElement.children[0];
            const count = child.assignedElements().length;
            if (count > 0) {
                this.hasChildren = true;
            }
            if (this.expanded) {
                this.expander.classList.add("expanded");
                this.collapsible.expanded = false;
                setTimeout(() => {
                    this.collapsible.expanded = true;
                }, 300);
            }
        });
    }
    toggleCollapse() {
        this.expanded = !this.expanded;
        if (this.expanded) {
            this.expander.classList.add("expanded");
            this.userExpanded.emit();
            return;
        }
        this.expander.classList.remove("expanded");
        this.userCollapsed.emit();
    }
    getTabIndex() {
        if (!this.hasChildren) {
            return -1;
        }
        return this.focused ? -1 : 0;
    }
    render() {
        return (h(Host, { key: '9239fbebdd6994b6df4fe0e07cb8ad2a9162cdf3', tabIndex: this.getTabIndex(), onFocus: () => { var _a; return (_a = this.button) === null || _a === void 0 ? void 0 : _a.focus(); }, onBlur: () => { var _a; return (_a = this.button) === null || _a === void 0 ? void 0 : _a.blur(); } }, h("div", { key: '823ca5c4685cda9e917620eb875b84deccadcbc7', class: "expander", ref: el => this.expander = el }, this.hasChildren &&
            h("button", { key: '195827a4a30353e8ada07e672715462f67dfbf36', ref: el => this.button = el, onClick: () => this.toggleCollapse(), onFocus: () => this.focused = true, onBlur: () => this.focused = false }, h("svg", { key: '61d9696936d4ed74058d5c324333661844ff1b00', xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 0 24 24", width: "24px", fill: "#000000" }, h("path", { key: '52e1f643b8e5119111b244e84f68e9b2b0fd5c64', d: "M10 17l5-5-5-5v10z" }), h("path", { key: 'afac6879313e031dac1e5949ebe00d639decf4c4', d: "M0 24V0h24v24H0z", fill: "none" })))), h("div", { key: '0b27c152b7a34a8723c81d35b568644c46799bc9', class: "item" }, h("div", { key: 'ebfa06a7283da2513d547b4ef88716f04022d6cb', class: "item-slot" }, h("slot", { key: '334db821df034666b9ba801abd7d5a9b45b013cf' })), h("dnn-collapsible", { key: '3b935ccb97e28b0d782740540a57c1658db2d0ea', ref: el => this.collapsible = el, expanded: this.expanded }, h("div", { key: '2eec927ff0cbbb3c71df32ed98b02a0d480d5283', ref: el => this.childElement = el }, h("slot", { key: '768790449686500938e3ae5ed41aea0d438e903c', name: "children" }))))));
    }
    static get is() { return "dnn-treeview-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dnn-treeview-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dnn-treeview-item.css"]
        };
    }
    static get properties() {
        return {
            "expanded": {
                "type": "boolean",
                "attribute": "expanded",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Defines if the current node is expanded."
                },
                "getter": false,
                "setter": false,
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "hasChildren": {},
            "focused": {}
        };
    }
    static get events() {
        return [{
                "method": "userExpanded",
                "name": "userExpanded",
                "bubbles": false,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fires when the user expands a node."
                },
                "complexType": {
                    "original": "void",
                    "resolved": "void",
                    "references": {}
                }
            }, {
                "method": "userCollapsed",
                "name": "userCollapsed",
                "bubbles": false,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fires when the user collapses a node."
                },
                "complexType": {
                    "original": "void",
                    "resolved": "void",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "expanded",
                "methodName": "watchExpanded"
            }];
    }
}
//# sourceMappingURL=dnn-treeview-item.js.map
